export const ATL_SELECTION_TYPE = {
  TBD: 1,
  ATL: 2,
  ATL_WITH_OBSERVER: 3,
  VIEW_ATL: 4,
  ATL_PREFERENCES: 5,
  VIEW_ATL_WITH_OBSERVER: 6
};

export const EDITABLE_SELECTION_TYPES = [
  ATL_SELECTION_TYPE.ATL,
  ATL_SELECTION_TYPE.ATL_WITH_OBSERVER,
  ATL_SELECTION_TYPE.ATL_PREFERENCES
];
